import { render, staticRenderFns } from "./PaymentDocumentsPage.vue?vue&type=template&id=5db9746f&scoped=true"
import script from "./PaymentDocumentsPage.vue?vue&type=script&lang=js"
export * from "./PaymentDocumentsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db9746f",
  null
  
)

export default component.exports